"use strict";

import * as Dropdown from '../../Dropdown.js';

export const classDropdownDiv = Dropdown.default;

